import { Box, Button, Typography } from "@mui/material";
import { mainTextColor } from "./utility/colorPalette";
import { useNavigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { getFormattedDate } from "./utility/getFormattedDate";

export const RemindingEventPage = () => {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const todaysDate: string = getFormattedDate();

  const startButtonClicked = () => {
    navigate("/pre-questionnaire", {
      state: { userId: user.userId, date: todaysDate },
    });
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ height: "2rem" }} />
      <Typography color={mainTextColor}>
        一日を振り返って、『よかったな』と思える出来事を思い出してみてください。
      </Typography>
      <Box sx={{ height: "2rem" }} />

      <Typography color={mainTextColor}>
        どんなにささいな事でも大丈夫です。ゆっくりで良いので、探してみましょう。
      </Typography>
      <Box sx={{ height: "2rem" }} />

      <Typography color={mainTextColor}>
        出来事を１つ思い出すことが出来たら、以下のボタンから進んでください。
      </Typography>

      <Box sx={{ height: "6rem" }} />

      <Box sx={{ textAlign: "center" }}>
        <Button variant="contained" onClick={startButtonClicked}>
          事前アンケートへ
        </Button>
      </Box>
    </Box>
  );
};
